import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { Icon } from '../Icon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PaymentSvg = function PaymentSvg() {
  return /*#__PURE__*/_jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M9.215 10.154a1.66 1.66 0 0 1 1.667-1.652h2.315c.92 0 1.667.74 1.667 1.652v.458h-1.482v-.458a.184.184 0 0 0-.185-.184h-2.315a.184.184 0 0 0-.185.184v.41c0 .086.06.161.145.18l2.717.598a1.655 1.655 0 0 1 1.305 1.612v.87a1.66 1.66 0 0 1-1.667 1.65h-2.315a1.66 1.66 0 0 1-1.667-1.65v-.46h1.482v.46c0 .1.083.183.185.183h2.315a.184.184 0 0 0 .185-.184v-.87c0-.085-.06-.16-.145-.178l-2.716-.598a1.655 1.655 0 0 1-1.306-1.612zM7.37 12.723H5.52v-1.468H7.37zM16.63 12.723h1.852v-1.468H16.63z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M22 5.75H2v12.477h20zM3.481 16.76V7.217H20.52v9.541z",
      clipRule: "evenodd"
    })]
  });
};
export var Payment = function Payment(props) {
  return /*#__PURE__*/_jsx(Icon, _objectSpread(_objectSpread({}, props), {}, {
    component: PaymentSvg
  }));
};